(function () {
  var STORAGE_KEY = 'tsq:newsletter-popup-dismissed';
  var SHOW_DELAY_MS = 4000;

  class NewsletterPopup extends HTMLElement {
    constructor() {
      super();
      this.querySelectorAll('[data-newsletter-popup-close]').forEach(
        function (el) {
          el.addEventListener('click', this.close.bind(this));
        }.bind(this)
      );
      document.addEventListener(
        'keyup',
        function (event) {
          if (event.code === 'Escape' && !this.hidden) this.close();
        }.bind(this)
      );
    }

    connectedCallback() {
      if (this.hasAttribute('data-just-subscribed')) {
        this.open();
        this.markDismissed();
        return;
      }

      var dismissed = true;
      try {
        dismissed = !!window.localStorage.getItem(STORAGE_KEY);
      } catch (error) {
        dismissed = true;
      }
      if (dismissed) return;

      window.setTimeout(this.open.bind(this), SHOW_DELAY_MS);
    }

    open() {
      this.hidden = false;
      document.body.classList.add('overflow-hidden');
    }

    close() {
      this.hidden = true;
      document.body.classList.remove('overflow-hidden');
      this.markDismissed();
    }

    markDismissed() {
      try {
        window.localStorage.setItem(STORAGE_KEY, '1');
      } catch (error) {
        // localStorage unavailable - fail silently.
      }
    }
  }

  if (!customElements.get('newsletter-popup')) {
    customElements.define('newsletter-popup', NewsletterPopup);
  }
})();
